<template>
    <DefaultHeader />
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-auto">
                <input v-model="lat1" type="text" class="form-control" placeholder="Lat 1">
            </div>
            <div class="col-auto">
                <input v-model="long1" type="text" class="form-control" placeholder="Long 1">
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-auto">
                <input v-model="lat2" type="text" class="form-control" placeholder="Lat 2">
            </div>
            <div class="col-auto">
                <input v-model="long2" type="text" class="form-control" placeholder="Long 2">
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-auto">
                <ButtonDisplay
                :type="'search'"
                :text="'Calculer'"
                @click="this.calc()" />
            </div>
            <div class="col-auto">
                {{ this.distance }}
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-auto">
                <ButtonDisplay
                :type="'save'"
                :text="'Bouger'"
                @click="this.moveOn()" />
            </div>
            <div class="col-auto">
                <ButtonDisplay
                :type="'save'"
                :text="'Replacer'"
                @click="this.moveBack()" />
            </div>
        </div>
    </div>
    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import GPSDist from '@/services/gpsDist.service.js'
import TestService from '@/services/test.service.js'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        ButtonDisplay
    },
    data() {
        return {
            distance: null,
            lat1: null,
            long1: null,
            lat2: null,
            long2: null,
        };
    },
    methods: {
        calc() {
            this.distance = GPSDist.calcDist(this.lat1,this.long1,this.lat2,this.long2)
        },
        moveOn() {
            TestService.moveOn()
        },
        moveBack() {
            TestService.moveBack()
        },
    }
}
</script>